<template>
  <crud-modal
    :title="$t('components.modals.campaign.addCreatifyTitle')"
    action="create"
    :on-submit="submit"
    :on-close="() => $emit('close')"
  >
    <div class="mb-6">
      <input-text-validated
        ref="name"
        v-model="name"
        input-class="w-full"
        :label="$t('components.modals.campaign.campaignName')"
        rules="required"
        placeholder="Bundestagswahl 2021"
      />
    </div>

    <div class="mb-6">
      <input-text-validated
        ref="templateId"
        v-model="templateId"
        input-class="w-full"
        label="Template Id"
        rules="required"
        placeholder="763fdeae-b11b-4b9c-b27a-77c9c9556afe"
      />
    </div>

    <creatify-variants v-model="variants" />
  </crud-modal>
</template>

<script>
import CrudModal from '@/components/modals/crud-modal'
import InputTextValidated from '@/components/form/text-validated'
import CreatifyVariants from '@/components/form/creatify-variants'

import GET_CAMPAIGN from '@/graphql/GetCampaign.gql'
import CREATE_VIDEO_MATERIAL_TEMPLATE_FOR_CAMPAIGN from '@/graphql/CreateVideoMaterialTemplateForCampaign.gql'

export default {
  components: { CrudModal, InputTextValidated, CreatifyVariants },
  props: {
    campaignId: { type: String, required: true }
  },
  data () {
    return {
      name: '',
      templateId: '',
      variants: []
    }
  },
  methods: {
    async submit () {
      this.$apollo.mutate({
        mutation: CREATE_VIDEO_MATERIAL_TEMPLATE_FOR_CAMPAIGN,
        variables: {
          input: {
            campaignId: this.campaignId,
            name: this.name,
            templateId: this.templateId,
            variants: this.variants
          }
        },
        refetchQueries: [{ query: GET_CAMPAIGN, variables: { campaignId: this.campaignId } }]
      })
    }
  }
}
</script>
